import Footer from "components/footer/FooterAuthDefault";
import Card from "components/card";
import phoneImg from "assets/img/home/phone.png";
import appstoreImg from "assets/img/home/appstore.png";
import playstoreImg from "assets/img/home/playstore.png";
import CustomHeader from "views/home/CustomHeader";
import {React} from 'react';

export default function Home() {
   
  
  return (
    <div>
      <div className="relative float-right h-full min-h-screen w-full dark:!bg-navy-700">
        <main className={`mx-auto min-h-screen`}>
          <div className="mx-auto flex min-h-full w-full flex-col pt-12 md:max-w-[85%] lg:h-screen lg:pt-0 xl:h-[100vh] xl:px-0 xl:pl-[70px] ">
            <Card extra={"w-full p-2 md:p-24 bg-white rounded-none dark:!bg-navy-700"}>
              <CustomHeader type={1} />
              <div className="mt-16 w-full rounded-xl bg-navyPink dark:!bg-navy-900 3xl:p-24 p-2 lg:p-24 2xl:p-1">
                <div className="grid xl:grid-cols-2">
                  <div>
                    <p className="text-xl font-bold md:text-2xl xl:text-xl  ">
                      УХААЛАГ УТАСНЫ <br />
                      ХУВИЛБАРЫГ СУУЛГААРАЙ
                    </p>
                    <p className="mt-8 mb-7 text-base font-normal xl:text-base 4xl:text-xl">
                      Сургуулийн удирдлага таны бүртгэлийг <br />
                      баталгаажуулах бөгөөд үүний дараа уг системийг
                      <br /> хэрэглэх боломжтой болох юм.
                    </p>
                  </div>

                  <div className="mt-10 grid grid-cols-2 justify-center gap-5 xl:mt-0 3xl:-mt-24">
                    <div className="col-span-2 flex justify-center">
                      <img src={phoneImg} className="w-6/12 lg:w-9/12" alt="" />
                    </div>
                      <a
                      className="flex justify-end"
                        target="blank"
                        href="https://play.google.com/store/games"
                      >
                        <img
                          src={playstoreImg}
                          className="mb-3 h-12 xl:h-20"
                          alt=""
                        />
                      </a>
                      <a target="blank" href="https://www.apple.com/app-store/">
                        <img src={appstoreImg} className="mb-3 h-12 xl:h-20" alt="" />
                      </a>
                  </div>
                </div>
              </div>
              {/*END CENTER */}
            </Card>
          </div>
          {/* </div> */}
        </main>
        <Footer />
      </div>
    </div>
  );
}
